import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/call-icon-default.svg';
import _imports_1 from '@/assets/call-icon.svg';
const _withScopeId = (n) => (_pushScopeId("data-v-ca3160bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "userBlock" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "number" };
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 0,
    src: _imports_0,
    alt: "call icon"
};
const _hoisted_7 = {
    key: 1,
    src: _imports_1,
    alt: "call icon"
};
const _hoisted_8 = { class: "carInfoBlock" };
const _hoisted_9 = { class: "carInfo" };
const _hoisted_10 = ["src"];
const _hoisted_11 = { class: "vehicle" };
const _hoisted_12 = { class: "vehicle-num" };
const _hoisted_13 = { class: "serviceInfo" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "Service Scheduled Time", -1));
const _hoisted_15 = {
    key: 0,
    class: "time"
};
const _hoisted_16 = { class: "serviceInfo" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "Service Notes", -1));
const _hoisted_18 = { class: "desc" };
import { getAppName } from "../../apiConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InfoBlock',
    props: {
        data: {}
    },
    setup(__props) {
        const project = getAppName() || process.env.VUE_APP_NAME;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("figure", {
                        class: _normalizeClass(_unref(project) !== 'ultimate' ? 'rounded' : '')
                    }, [
                        _createElementVNode("img", {
                            src: _ctx.data.customerDetails.photoUrl,
                            alt: "user photo"
                        }, null, 8, _hoisted_2)
                    ], 2),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.customerDetails.fullName), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.customerDetails.primaryPhone), 1)
                    ]),
                    _createElementVNode("a", {
                        href: 'tel:' + _ctx.data.customerDetails.primaryPhone,
                        class: "call"
                    }, [
                        (_unref(project) !== 'ultimate')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                            : _createCommentVNode("", true),
                        (_unref(project) === 'ultimate')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("figure", null, [
                            _createElementVNode("img", {
                                src: _ctx.data.customerVehicle.imageUrl,
                                alt: "vehicle image",
                                width: "112",
                                height: "50"
                            }, null, 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.data.customerVehicle.make) + " " + _toDisplayString(_ctx.data.customerVehicle.variant) + " " + _toDisplayString(_ctx.data.customerVehicle.modelYear), 1),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.data.customerVehicle.licensePlate), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        (_ctx.data.appointmentDateAndTime)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Started At " + _toDisplayString(new Date(_ctx.data.appointmentDateAndTime).toLocaleString("en-US", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                                timeZone: _ctx.data.timeZone,
                            })), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.data.serviceNote), 1)
                    ])
                ])
            ]));
        };
    }
});
